import {
  canEditCompletion,
  isCompletionLocked,
  isTerminalCompleted
} from '../../../operationalDomain/completion/completionLock';
import type { OperationalCompletionSnapshotPayload } from '../../../operationalDomain/completion/completionSnapshot';
import type { CompletionLockProjection } from './types';

export function buildCompletionLockProjection(params: {
  routeStatus: string | null | undefined;
  snapshot: OperationalCompletionSnapshotPayload | null;
}): CompletionLockProjection {
  const locked = isCompletionLocked({
    routeStatus: params.routeStatus,
    snapshot: params.snapshot
  });
  return {
    locked,
    terminalCompleted: isTerminalCompleted(params.routeStatus, params.snapshot),
    canEdit: canEditCompletion({
      routeStatus: params.routeStatus,
      snapshot: params.snapshot
    }),
    completedAt: params.snapshot?.completedAt ?? null,
    logistComment: params.snapshot?.logistComment ?? null
  };
}
